import React, { Component } from "react";
import "./Jobs.css";
import ReactPaginate from "react-paginate";
import $ from "jquery";
import OutsideClickHandler from "react-outside-click-handler";
import { Row, Col } from "react-bootstrap";
import { FiThumbsUp } from "react-icons/fi";
import { NotificationManager } from "react-notifications";
import { NavLink } from "react-router-dom";
import { Container } from "@mui/material";

class JobsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consumeruserparent: "consumer2",
      tenders: [],
      tendersFilter: [],
      offset: 0,
      tensdersPageCount: 1,
      perPage: 3,
      currentPage: 0,
      checked: false,
      postCategoryIdVlaue: "",
      InitialAccessToken: localStorage.getItem("GlobalAccess"),
      subCategoriesList: [],
      copyOfTenders: [],
      contentOwners: [],
    };
    this.handlePageClick = this.handlePageClick.bind(this);
    this.isComponentMounted = false
  }

// Lifecycle method that runs after the component is mounted
componentDidMount() {
  this.postCategoryIdValue();  // Fetches category ID when the component mounts
}

// Function to fetch category ID based on "JOBS" category name
postCategoryIdValue() {
  this.isComponentMounted = true;  // Flag to check if the component is still mounted
  fetch(
    `${window.appConfig.getContentCategories}${window.appConfig.Relam}${window.appConfig.Relam}`,
    {
      method: "GET", // HTTP method for GET request
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken, // Include the token for authorization
      },
    }
  )
    .then((res) => res.json())  // Parse the JSON response
    .then((result) => {
      if (!this.isComponentMounted) return; // If component is unmounted, exit the function

      // Find category ID for "JOBS"
      const postid = result.categoryList.filter(
        (data) => data.categoryname === "JOBS"
      );

      if (postid.length === 0) {
        console.warn("No matching category found");
        return;  // Exit if no category is found
      }

      const categoryId = postid[0].categoryid;  // Extract category ID

      // Call various methods based on the category ID
      this.viewAllJobs(categoryId);  
      this.setState({
        postCategoryIdValue: categoryId,  // Store category ID in state
      });
      this.adminsDropdownClick(categoryId);  // Fetch admins based on category
      this.getCategorySubcategories(categoryId);  // Fetch subcategories
      this.ownerDropdownClick(categoryId);  // Fetch content owners
    })
    .catch((err) => console.log("Fetch error:", err));  // Handle errors
}

// Cleanup when the component is unmounted
componentWillUnmount(){
  this.isComponentMounted = false;  // Set flag to false when component is unmounted
}

// Function to fetch all jobs for a given category ID
viewAllJobs(postid) {
  fetch(
    `${window.appConfig.getContentList}${window.appConfig.Relam}category/${postid}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    }
  )
    .then((res) => res.json())  // Parse the JSON response
    .then((result) => {
      // Update state with the fetched job data
      this.setState({
        tenders: result.contentList,
        copyOfTenders: result.contentList,  // Store a copy of the job data for filtering
        tensdersPageCount: Math.ceil(
          result.contentList.length / this.state.perPage  // Calculate the number of pages for pagination
        ),
      });
    });
}

// Function to fetch content creators for a given category ID
adminsDropdownClick(catID) {
  fetch(
    `${window.appConfig.getContentCreator}${window.appConfig.Relam}contentcreators/${catID}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    }
  )
    .then((res) => res.json())  // Parse the JSON response
    .then((result) => {
      // Remove duplicates from the content creators list
      const unique = [
        ...new Map(
          result.contentcreatorsList.map((data) => [data.contentcreatorid, data])
        ).values(),
      ];
      this.setState({
        tendersFilter: unique,  // Store unique content creators in state
      });
    })
    .catch((err) => console.log("err", err));  // Handle errors
}

// Function to toggle visibility of the jobs dropdown
organizationsDropdownClick() {
  $("#dropdownJobs").toggle();  // Toggle dropdown visibility
}

// Function to fetch and filter jobs based on selected content creator
organizationsOnClick(Creator) {
  fetch(
    `${window.appConfig.getContentonContentCreator}${window.appConfig.Relam}contentcreator/${Creator}/${this.state.postCategoryIdVlaue}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    }
  )
    .then((res) => res.json())  // Parse the JSON response
    .then((result) => {
      // Update state with filtered job content
      this.setState({
        tenders: result.contentList,
        tensdersPageCount: Math.ceil(
          result.contentList.length / this.state.perPage
        ),
      });
    })
    .catch((err) => console.log("err", err));  // Handle errors
  $("#dropdownJobs").hide();  // Hide dropdown after selection
}

// Function to fetch subcategories based on category ID
getCategorySubcategories(catID) {
  if(!catID) return;  // Exit if category ID is not provided
  fetch(`${window.appConfig.getContentSubcategories}${window.appConfig.Relam}${window.appConfig.Relam}${window.appConfig.Relam}${catID}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    }
  )
    .then((res) => res.json())  // Parse the JSON response
    .then((result) => {
      // Update state with fetched subcategories
      this.setState({
        subCategoriesList: result.contentsubcategories,
      });
    })
    .catch((err) => console.log("err", err));  // Handle errors
}

// Function to toggle visibility of the subcategories dropdown
subCategoriesDropdownClick() {
  $("#subCategoriesOfJobs").toggle();  // Toggle dropdown visibility
}

// Function to filter and display jobs based on selected subcategory
subCategoriesOnClick(subCategory) {
  const subCategoriesOfAdsFilter = this.state.copyOfTenders.filter(
    (data, index) => {
      return data.contentsubcategory
        .toLowerCase()
        .includes(subCategory.toLowerCase());  // Filter based on subcategory
    }
  );
  this.setState({
    tenders: subCategoriesOfAdsFilter,  // Update state with filtered tenders
    tensdersPageCount: Math.ceil(
      subCategoriesOfAdsFilter.length / this.state.perPage
    ),
  });
  $("#subCategoriesOfJobs").hide();  // Hide dropdown after selection
}

// Function to like a content item and fetch the updated list of jobs
likeCount(contentid) {
  fetch(
    `${window.appConfig.contentLikeCount}${window.appConfig.Relam}${contentid}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    }
  )
    .then((res) => res.text())  // Parse the response as text
    .then((result) => {
      this.postCategoryIdValue();  // Refresh the category data
      return NotificationManager.success(result);  // Display success notification
    })
    .catch((err) => console.log("err", err));  // Handle errors
}

// Function to fetch content owners based on category ID
ownerDropdownClick(catID) {
  fetch(
    `${window.appConfig.getAllContentOwnersBasedOnCategory}${catID}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    }
  )
    .then((res) => res.json())  // Parse the JSON response
    .then((result) => {
      // Remove duplicates from the content owners list
      const unique = [
        ...new Map(
          result.contentownerList.map((data) => [data.contentowner, data])
        ).values(),
      ];
      this.setState({
        contentOwners: unique,  // Store unique content owners in state
      });
    })
    .catch((err) => console.log("err", err));  // Handle errors
}

// Function to toggle visibility of the content owner dropdown
contentOwnerDropdownClick(){
  $("#ContentOwnerOfJobs").toggle();  // Toggle dropdown visibility
}

// Function to fetch and filter content based on selected content owner
getContentOwnerContent(Owner) {
  fetch(
    `${window.appConfig.getContentList}${window.appConfig.Relam}contentowner/${Owner}/${this.state.postCategoryIdVlaue}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    }
  )
    .then((res) => res.json())  // Parse the JSON response
    .then((result) => {
      // Update state with filtered content based on owner
      this.setState({
        tenders: result.contentList,
        tensdersPageCount: Math.ceil(
          result.contentList.length / this.state.perPage
        ),
      });
    })
    .catch((err) => console.log("err", err));  // Handle errors
  $("#dropdownOrganizations").hide();  // Hide dropdown after selection
}

// Pagination handler
handlePageClick = (e) => {
  const selectedPage = e.selected;  // Get the selected page number
  const offset = selectedPage * this.state.perPage;  // Calculate the offset for the current page

  this.setState(
    {
      currentPage: selectedPage,  // Update the current page in state
      offset: offset,  // Update the offset for pagination
    },
    () => {}
  );
};


render() {
  // Destructuring state values for tenders, subCategoriesList, and contentOwners
  const { tenders, subCategoriesList, contentOwners } = this.state;

  // Slicing the tenders array based on the current offset and perPage values
  const tendersList = tenders.slice(
    this.state.offset,
    this.state.offset + this.state.perPage
  );

  return (
    <Container>
      <div
        id="tendersContainer"
        className="mb-lg-5 mb-4 mt-4 gbr-engage-container container-fluid"
      >
        {/* Title Section */}
        <h3 className="container-title">Jobs</h3>

        {/* Dropdown Filters Section */}
        <div className="mb-4">
          {/* Button to view all jobs */}
          <div className="dropdown">
            <div className="navbarRight">
              <button
                className="btn btn-success homepageBtn"
                type="button"
                onClick={() => this.viewAllJobs(this.state.postCategoryIdVlaue)}
              >
                All Jobs
              </button>
            </div>
          </div>

          {/* Job Publisher Filter Dropdown */}
          <div className="dropdown">
            <div className="dropdown homepage-nav-item">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => this.organizationsDropdownClick()}
                >
                  Job Publisher
                </button>
              </div>
              <div
                className="dropdown-menu"
                id="dropdownJobs"
                aria-labelledby="dropdownJobs"
              >
                {/* Map through available tenders filters and display them */}
                {this.state.tendersFilter &&
                  this.state.tendersFilter.map((filter, i) => (
                    <li key={i}>
                      <a
                        className="dropdown-item"
                        role="button"
                        onClick={() =>
                          this.organizationsOnClick(filter.contentcreatorid)
                        }
                      >
                        {filter.contentcreatorid}
                      </a>
                    </li>
                  ))}
              </div>
            </div>
          </div>

          {/* Sub Categories Filter Dropdown */}
          <div className="dropdown">
            <div className="dropdown homepage-nav-item">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => this.subCategoriesDropdownClick()}
                >
                  Sub Categories
                </button>
              </div>
              <div
                className="dropdown-menu"
                id="subCategoriesOfJobs"
                aria-labelledby="subCategoriesOfJobs"
              >
                {/* Map through subcategories list and display each */}
                {subCategoriesList &&
                  subCategoriesList.map((filter, i) => (
                    <li key={i}>
                      <a
                        className="dropdown-item"
                        role="button"
                        onClick={() =>
                          this.subCategoriesOnClick(filter.contentsubcategoryname)
                        }
                      >
                        {filter.contentsubcategoryname}
                      </a>
                    </li>
                  ))}
              </div>
            </div>
          </div>

          {/* Club Owner Filter Dropdown */}
          <div className="dropdown">
            <div className="dropdown homepage-nav-item">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => this.contentOwnerDropdownClick()}
                >
                  Club Owner
                </button>
              </div>
              <div
                className="dropdown-menu"
                id="ContentOwnerOfJobs"
                aria-labelledby="ContentOwnerOfJobs"
              >
                {/* Map through content owners list and display each */}
                {contentOwners &&
                  contentOwners.map((filter, i) => (
                    <li key={i}>
                      <a
                        className="dropdown-item"
                        role="button"
                        onClick={() =>
                          this.getContentOwnerContent(filter.contentowner)
                        }
                      >
                        {filter.contentowner}
                      </a>
                    </li>
                  ))}
              </div>
            </div>
          </div>
        </div>

        {/* Tenders Display Section */}
        <div className="adminTendersDiv">
          {/* Check if there are tenders to display */}
          {tendersList.length !== 0 ? (
            <Row className="justify-content-center">
              {/* Loop through tendersList and display each tender */}
              {tendersList.map((tend, index) => (
                <Col md={6} lg={4} sm={12} xs={12} className="mb-4" key={index}>
                  <div className="community-cards w-100">
                    <div className="bordered-div"></div>
                    <div className="pb-2">
                      <div className="scrollable-container">
                        <div className="community-card-body">
                          <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
                            {/* Display subcategory and like count */}
                            <span className=" d-block ">
                              {tend.contentsubcategory}
                            </span>
                            <p className="products-like mb-0 d-flex align-items-end">
                              <span
                                className="d-inline-block"
                                onClick={() => {
                                  this.likeCount(tend.contentid);
                                }}
                              >
                                <FiThumbsUp size={30} />
                              </span>
                              <small>{tend.likecount}</small>
                            </p>
                          </div>

                          <h2 className="mb-0">{tend.contentname}</h2>

                          {/* Display additional details about the tender */}
                          <h5 className="mb-2">
                            Posted by <span>{tend.contentcreatorid}</span>,{" "}
                            {tend.timestamp}
                          </h5>
                          <a className="text-decoration-none" href={tend.texturl} target="_blank">
                            <h6 className="mb-3">{tend.contentdescription}</h6>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Button to download document */}
                  <div className="community-button-container p-3 px-0 text-center mt-2">
                    <NavLink
                      className="downloadDocument mt-0 "
                      to="/auth/10/signin"                     
                    >
                      Download Document
                    </NavLink>
                  </div>
                </Col>
              ))}
              {/* Pagination Component */}
              <div className="paginationComponent">
                <ReactPaginate
                  previousLabel={"<<"}
                  nextLabel={">>"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={this.state.tensdersPageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            </Row>
          ) : (
            // Display message if no tenders are found
            <div className="card">
              <p className="card-body container-heading2">
                <b>Jobs Not Found</b>
              </p>
            </div>
          )}
        </div>

        {/* Outside Click Handler to hide dropdowns when clicking outside */}
        <OutsideClickHandler
          onOutsideClick={() => {
            $("#dropdownJobs").hide();
            $("#subCategoriesOfJobs").hide();
            $("#ContentOwnerOfJobs").hide();
          }}
        ><></></OutsideClickHandler>
      </div>
    </Container>
  );
}

}

export default JobsComponent;
